import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import styles from './ThemeToggle.module.css'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const label = theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'

  return (
    <div className={styles.themeToggleContainer}>
      <button
        type="button"
        className={styles.themeToggleButton}
        onClick={toggleTheme}
        aria-label={label}
      >
        {theme === 'dark' ? <Sun /> : <Moon />}
      </button>
    </div>
  )
}
